const garagesList = document.querySelector('.garagesList');

if (garagesList && Array.from(garagesList.childNodes).some((child) => child.nodeName === 'LI')) {
    garagesList.parentElement.style.display = 'block';
}
